import React, { useState } from "react";
import AccessControl from "../../../../../../HOC/AccessControl";
import styles from "./OrderControl.module.sass";
import cn from "classnames";
import Icon from "../../../../../../components/Icon";
import OrderPreview from "./OrderPreview";
import {GET_ORDER_MEDIA} from "../../../../../../API/Orders"
import { message } from "antd";
import moment from "moment";

const Control = ({ className, item, handleDelete }) => {
  const [visibleModalProduct, setVisibleModalProduct] = useState(false);
  const [visibleModalPreview, setVisibleModalPreview] = useState(false);
  const [loading, setLoading] = useState(false);

  const extractFilename = (url, type) => {
    const regex = /\/([^\/]+-\d{5})/;
    const match = url.match(regex);
    const storeName = item.employee.store.store_name || "store";
    const employeeName = item.employee.full_name || " ";
    const packerTime = moment(item.created_at).format("YYYY-MM-DD") || "packer";
    if (match) {
      return `${storeName}_${employeeName}_${packerTime}.${type === "image" ? "jpg" : "mp4"}`;
    }
    return "downloaded_file"; // fallback filename
  };
  const handleDownload = async () => {
    setLoading(true);
    message.warning("Loading...") 
    try {
      const response = await GET_ORDER_MEDIA(item.media_url, item.media_type);
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const filename = extractFilename(item.media_url, item.media_type);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      setLoading(false); 
    } catch (error) {
      console.error("Error during download:", error);
      message.error("Failed to download file. Please try again later.");
      setLoading(false);
    }
  };
  const handleCopyShareableUrl = () => {
    if (item && item.shareable_url) {
      navigator.clipboard
        .writeText(item.shareable_url)
        .then(() => {
          message.success("Shareable URL copied to clipboard");
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
          message.error("Failed to copy URL to clipboard");
        });
    } else {
      message.error("Shareable URL not available");
    }
  };
  const media = item
    ? (Array.isArray(item) ? item : [item]).filter(Boolean)
    : [];
  const isVideo = item.media_type === "video";
  const hasShareableUrl = item && item.shareable_url;
  const actions = [
    {
      icon: isVideo ? "play" : "eye",
      action: () => setVisibleModalPreview(true),
      moduleCode: "",
      requiredPrivilege: "",
    },

    {
      icon: "trash",
      action: () => {
        if (item && item.id) {
          // console.log("Attempting to remove media with ID:", item.id);
          if (typeof handleDelete === "function") {
            handleDelete(item.id); // Call the function with media ID
          } else {
            // console.error("handleDelete is not a function");
          }
        } else {
          console.error("Item ID is missing or item is invalid.");
        }
      },
      moduleCode: "8FZN9w",
      requiredPrivilege: "esufk7",
    },
    {
      icon: "share",
      action: handleCopyShareableUrl,
      moduleCode: "",
      requiredPrivilege: "",
    },
  ];
  return (
    <>
      <div className={cn(styles.control, className)}>
       {hasShareableUrl && (
          <button className={styles.button} onClick={handleCopyShareableUrl}>
            <Icon name="share" size="20" />
          </button>
        )}
        <button className={styles.button} onClick={actions[0].action}>
          <Icon name={actions[0].icon} size="20" />
        </button>
        <AccessControl
          moduleCode={actions[1].moduleCode}
          requiredPrivilege={actions[1].requiredPrivilege}
        >
          <button className={styles.button} onClick={actions[1].action}>
            <Icon name={actions[1].icon} size="20" />
          </button>
        </AccessControl>
      </div>
      {item && (
        <OrderPreview
          visible={visibleModalPreview}
          onClose={() => setVisibleModalPreview(false)}
          media={media}
          title="PickPackGo"
          figcaption="Elegant product mockup for your next project"
          download={handleDownload}
        />
      )}
    </>
  );
};

export default Control;
